module.exports = __webpack_public_path__ + "845de52f549516b810e6386899dfcfaf.png";